import React from 'react'
import levels from './levels'

export class LevelComponent extends React.Component {
    render() {
        const level = this.props.level
        const type = level ? level.type : ''
        const LevelComponent = levels[type]
        return (
            <LevelComponent
                togglePause={this.togglePause}
                progress={this.roundPlayed}
                stage={this.stage}
                userBot={{}}
                score={0}
                level={level}
                onRoundComplete={this.onRoundComplete}
                onRoundFail={this.onRoundFail}
                onExit={this.props.onExit} />
        )
    }
}

export class BaseLevelLayoutComponent extends React.Component {
    updateSizes = (elem) => {
        if (elem) {
            this.setState({ containerWidth: elem.clientWidth, containerHeight: elem.clientHeight })
        }
    }
    render() {
        return (
            <div className='level-modal' ref={this.updateSizes} >
                {this.props.children}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/game/level.components.js